import { jsx as n } from "react/jsx-runtime";
import { Combobox as p } from "@headlessui/react";
function x({
  children: i,
  selectedData: r,
  virtual: m,
  disabled: l,
  onClose: t,
  onChange: u
}) {
  return /* @__PURE__ */ n(
    p,
    {
      immediate: !0,
      multiple: !0,
      value: r,
      virtual: m,
      onChange: (o) => u((o == null ? void 0 : o.filter((e) => e.id !== void 0).map((e) => e.id)) ?? []),
      disabled: l,
      onClose: t,
      children: ({ open: o }) => i(o)
    }
  );
}
export {
  x as ComboboxMultiple
};
